import '../../assets/vendor/bootstrap/css/bootstrap.min.css';
import '../../assets/vendor/bootstrap-icons/bootstrap-icons.css';
import '../../assets/vendor/boxicons/css/boxicons.min.css';
import '../../assets/vendor/quill/quill.snow.css';
import '../../assets/vendor/quill/quill.bubble.css';
import '../../assets/vendor/remixicon/remixicon.css';
import '../../assets/vendor/simple-datatables/style.css';
import '../../assets/css/style.css';
import '../Home/home'
import {UserLogout} from '../../Services/User/User'
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import ClearCache from '../../lib/clearCache';
import { UserUpdatePermissions } from '../../Services/User/User';
function Header(){
  const [username, setUsername] = useState('');
  useEffect(() => {
    const storedUsername = localStorage.getItem('username');
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, []);

 let classToggle = async () => {
    document.body.classList.toggle('toggle-sidebar');
   
  };
  const navigate = useNavigate();
  let  logOut= async ()=>{
    await UserLogout()
    navigate('/login')
  }
    return ( 
        <div>
            <header id="header" className="header fixed-top d-flex align-items-center">
      
          <div className="d-flex align-items-center justify-content-between">
            <div
              className="logo d-flex align-items-center"
              style={{ textDecoration: "none", cursor: "pointer" }}
              onClick={() => navigate("/")}
            >
              <img
                src="https://www.magikmat.com/wp-content/uploads/2023/09/MicrosoftTeams-image-10.png"
                alt="Magikmat"
              />
              <span className="d-none d-lg-block">Magikmat</span>
            </div>

            <i
              onClick={() => classToggle()}
              className="bi bi-list toggle-sidebar-btn"
            ></i>
          </div>
      <nav className="header-nav ms-auto">
        <ul className="d-flex align-items-center">
          <li className="nav-item dropdown">
            <ClearCache/>
          </li> 
          <li className="nav-item dropdown pe-3">
            <a className="nav-link nav-profile d-flex align-items-center pe-0" href="home"  data-bs-toggle="dropdown">
              {/* <img src="https://dev.admin.magikmat.net/assets/img/profilepic.webp" alt="Profile" className="rounded-circle" /> */}
              <span className="d-none d-md-block dropdown-toggle ps-2 username">{username}</span>
            </a> 
            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
              <li className="dropdown-header">
                <h6 className='username'>{username}</h6>
              </li>
              <li>
                <a className="dropdown-item d-flex align-items-center" id="userupdatepermissions" onClick={UserUpdatePermissions}href="#">
                  <i className="bi bi-arrow-up-circle"></i>
                  <span>Update Permissions</span>
                </a>
              </li>
              <li>
                <a className="dropdown-item d-flex align-items-center" href="/login" onClick={()=>logOut()}>
                  <i className="bi bi-box-arrow-right"></i>
                  <span>Sign Out</span>
                </a>
              </li>
  
            </ul> 
          </li>
        </ul>
      </nav>
  
    </header>
        </div>
         
    );
}
export default Header;